import createModel from 'utils/model'
import _ from 'lodash'
import {
    getTableData,
    getStat,
    exportExcel,
    mainMinisoExportExcel,
} from 'crm/services/drainage-channel-stat'
import dayjs from 'dayjs'
import constants from 'crm/common/constants'

const {dateFormat} = constants

function getInitTableParamsState() {
    return {
        state: undefined, // 渠道id
        date_from: `${dayjs().subtract(6, 'days').format(dateFormat)}`,
        date_to: `${dayjs().format(dateFormat)}`,
        limit: 10,
        offset: 0,
    }
}

function getInitTableState() {
    return {
        params: getInitTableParamsState(),
        searchParams: {},
        total: 0,
        current: 1,
        tableData: [],
        stat: {},
    }
}

export default createModel({
    namespace: 'crm_drainage_channelStat',

    state: {
        ...getInitTableState(),
    },

    effects: {
        // 列表
        *getTableData({payload}, {select, call, put}) {
            const {params, current} = yield select(
                ({crm_drainage_channelStat}) => crm_drainage_channelStat,
            )

            const newParams = _.cloneDeep(params)
            if (payload.page) {
                newParams.offset = newParams.limit * (payload.page - 1)
            }

            const res = yield call(getTableData, newParams)
            const newData = res.data

            newData.forEach((item, index) => {
                item.id = index + 1
            })
            yield put({
                type: 'setProperty',
                payload: {
                    searchParams: newParams,
                    tableData: newData,
                    total: _.get(res, 'pagination.rows_found', 0),
                    current: _.get(payload, 'page', current),
                },
            })
        },

        // 概况
        *getStat(xx, {select, call, put}) {
            const {params} = yield select(({crm_drainage_channelStat}) => crm_drainage_channelStat)

            const newParams = _.cloneDeep(params)
            delete newParams?.limit
            delete newParams?.offset
            const res = yield call(getStat, newParams)

            yield put({
                type: 'setProperty',
                payload: {
                    stat: res.data,
                },
            })
        },

        // 导出
        *exportExcel({payload}, {call}) {
            return yield call(exportExcel, payload)
        },

        // 大名创-导出
        *mainMinisoExportExcel({payload}, {call}) {
            return yield call(mainMinisoExportExcel, payload)
        },
    },

    reducers: {
        resetTableParams(state) {
            return {...state, params: getInitTableParamsState()}
        },
        resetTable(state) {
            return {...state, ...getInitTableState()}
        },
        mergeTableParams(state, action) {
            return {...state, params: {...state.params, ...action.payload}}
        },
    },
})
